import React from "react";
import { Bell, BellOff, BellRing, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { usePushAlerts } from "@lawyer/hooks/usePushAlerts";

const COPY = {
  on: { Icon: BellRing, label: "Booking alerts on", hint: "You'll be notified even when this tab is closed", cls: "border-emerald-300 text-emerald-200" },
  off: { Icon: Bell, label: "Enable booking alerts", hint: "Get a browser notification the moment a client books", cls: "border-[#D4AF37] text-[#D4AF37]" },
  blocked: { Icon: BellOff, label: "Alerts blocked in browser", hint: "Allow notifications for this site in your browser settings", cls: "border-white/20 text-slate-400" },
};

// Sidebar control for browser push alerts (listed lawyers only).
export function PushAlertsToggle() {
  const { state, busy, enable, disable } = usePushAlerts();
  if (state === "loading" || state === "unsupported" || state === "unavailable") return null;
  const c = COPY[state] || COPY.off;
  const onClick = async () => {
    if (state === "blocked") { toast.info(c.hint); return; }
    if (state === "on") { await disable(); toast.success("Booking alerts turned off"); return; }
    const ok = await enable();
    toast[ok ? "success" : "error"](ok ? "Booking alerts on — a test notification is on its way" : "Could not enable alerts. Please allow notifications and try again.");
  };
  return (
    <button
      type="button" onClick={onClick} disabled={busy} title={c.hint}
      data-testid="push-alerts-toggle" data-state={state}
      className={`mt-2 w-full text-[11px] font-bold px-2 py-1 rounded-md border inline-flex items-center justify-center gap-1 disabled:opacity-40 ${c.cls}`}
    >
      {busy ? <Loader2 size={10} className="animate-spin" /> : <c.Icon size={10} />} {c.label}
    </button>
  );
}
